import { Injectable } from '@angular/core';

@Injectable()
export class UserService {
    activeUser: any = null;

    constructor() {}

    setUser(user: any) {
        this.activeUser = user;
    }

    getUser(): any {
        return this.activeUser;
    }
}
